// import { stringify } from 'qs'

import axios from 'axios'

export async function reqShadowAnalysis(param: any) {
  return axios.post('/nddt/portal/server/api/httpForward/lx_uav_api_form_urlencoded', {
    url: `${window.SystemConfig.shadow_analysis_url}/shadow`,
    formData: param,
    userAccount: 'devUser',
    userId: 'devUser',
  })
}

export async function uploadImgToServer(formData: any) {
  return axios.post('/nddt/portal/server/api/file/uploadSHARE',
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } })
}
